import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import './Define.css'
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellWeek3(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered } = define;
   const [week3, setWeek3] = useState(params.row.weekly3);
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   useEffect(()=>{
      setWeek3(params.row.weekly3);
   },[params.row.weekly3]);

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly3: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }


   function updateWeek3(event) {
      let w3 = removeComma(event.target.value);
      w3 = Number(w3);
      let w2 = Number(params.row.weekly2);
      let w4 = Number(params.row.weekly4);
      let hasError = false;
      setWeek3(w3);
      if(!w3 && w3!==0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }

      if(w2 > w3) {
         hasError = true;
      }
      else if(w3 > w4) {
         hasError = true;
      }
      dispatch(setState("gridDataChanged", true));
      updateGrid(hasError, w3);
      dispatch(setTotalValues());
   }
   function handleValidity(w2, w3, w4){
      if(w2 > w3) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be greater or equal to Week2"));
      }
      else if(w3 > w4) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week4"));
      }
   }
   return (
      <TextField
         variant="standard"
         value={week3?.toLocaleString('en-US')}
         className={params.row.weekly3 > params.row.weekly4 ? 'red-row' : ''}
         onChange={updateWeek3}
         onBlur={() => {
            handleValidity(params.row.weekly2, params.row.weekly3, params.row.weekly4);
         }}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
